import React from 'react';
import Lottie from 'lottie-react';
import confirmed from '../../images/confirmed.json';

function PreviewDates(props) {
  var title = 'No date yet';
  var subtitle = 'Join and propose some dates.'
  var icon = (
    <div className="no-date-image u-pull-left">
      <i className="material-icons md-36 md-inactive u-pull-left">date_range</i>
    </div>
  );

  if (props.status === '1') {
    title = 'Date and time all set';
    subtitle = "Join to see all the details."
    icon = (
      <div className="confirmed-date-image u-pull-left">
        <Lottie animationData={confirmed} loop={false} className="animation" />
      </div>
    );
  }

  else if (props.dates.length == 1) {
    title = "1 date proposed";
    subtitle = "Join to see all the details."
  }
  
  else if (props.dates.length > 1) {
    title = props.dates.length + " dates proposed";
    subtitle = "Join to see all the details."
  }

  return (
    <React.Fragment>
      {icon}
      <table className="no-date-info">
        <tbody>
          <tr>
            <th>{title}</th>
          </tr>
          <tr>
            <td>{subtitle}</td>
          </tr>
        </tbody>
      </table>
    </React.Fragment>
  );
}

export default PreviewDates;
